import React, { useEffect, useState, useRef } from "react";
import { connect } from "react-redux";
const Resizable = require("react-resizable").ResizableBox;
import "./resizable.css";

import Editor from "./ReactSimpleCodeEditor";
import { highlight, languages } from "prismjs/components/prism-core";
import "prismjs/components/prism-clike";
import "prismjs/components/prism-javascript";
import "prismjs/components/prism-markup";
import "prismjs/components/prism-jsx";
import "prismjs/components/prism-css";

import "./htmlEditor.css";

const HTMLEditor = ({
  html,
  js,
  css,
  syncCode,
  bootstrap,
  width,
  height,
  syncSize,
}) => {
  let iframeRef = useRef(null);
  let bootstrapCDN = `<link rel="stylesheet" href="https://stackpath.bootstrapcdn.com/bootstrap/4.5.2/css/bootstrap.min.css" integrity="sha384-JcKb8q3iqJ61gNV9KGb8thSsNjpSL0n8PARn9HuZOnIxN0hoP+VmmDGMN5t9UJ0Z" crossorigin="anonymous">`;
  const runCode = () => {
    const iframe = iframeRef.current;
    const document = iframe.contentDocument;
    const documentContents = `
      <!DOCTYPE html>
      <html lang="en">
      <head>
        <meta charset="UTF-8">
        <meta name="viewport" content="width=device-width, initial-scale=1.0">
        <meta http-equiv="X-UA-Compatible" content="ie=edge">
        <title>Document</title>
        <style>
          ${css}
        </style>
        ${bootstrap ? bootstrapCDN : ""}
      </head>
      <body>
        ${html}
        <script type="text/javascript">
          ${js}
        </script>
      </body>
      </html>
    `;

    document.open();
    document.write(documentContents);
    document.close();
  };

  useEffect(() => runCode(), [html, css, js]);

  return (
    <div>
      <section className="playground">
        <div className="code-editor html-code">
          <div className="editor-header">HTML</div>
          <Editor
            value={html}
            mode="html"
            onValueChange={(code) => syncCode("html", code)}
            highlight={(code) => highlight(code, languages.jsx)}
            padding={10}
            style={{
              fontFamily: '"Fira code", "Fira Mono", monospace',
              fontSize: 14,
              color: "white",
            }}
          />
        </div> 
        <div className="code-editor css-code">
          <div className="editor-header">CSS</div>
          <Editor
            value={css}
            mode="css"
            onValueChange={(code) => syncCode("css", code)}
            highlight={(code) => highlight(code, languages.css)}
            padding={10}
            style={{
              fontFamily: '"Fira code", "Fira Mono", monospace',
              fontSize: 14,
              color: "white",
            }}
          />
        </div>
        <div className="code-editor js-code">
          <div className="editor-header">JavaScript</div>
          <Editor
            value={js}
            mode="js"
            onValueChange={(code) => syncCode("js", code)}
            highlight={(code) => highlight(code, languages.js)}
            padding={10}
            style={{
              fontFamily: '"Fira code", "Fira Mono", monospace',
              fontSize: 14,
              color: "white",
            }}
          />
        </div>
      </section>
      <section className="result">
        <Resizable
          height={height}
          width={width}
          resizeHandles={["se"]}
          onResizeStop={(_, data) => syncSize(data.size)}
        >
          <iframe title="result" className="iframe" ref={iframeRef} />
        </Resizable>
      </section>
    </div>
  );
};

const mapStateToProps = ({ html, css, js, width, height }) => {
  return {
    html,
    css,
    js,
    width,
    height,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    syncCode: (codeType, code) =>
      dispatch({
        type: "server/updateCodeEditor",
        data: { timestamp: Date.now(), codeType, code },
      }),
    syncSize: ({ width, height }) =>
      dispatch({
        type: "server/updateCodeEditorPreviewSize",
        data: { width, height },
      }),
  };
};

const ConnectedHTMLEditor =
  typeof window !== `undefined`
    ? connect(mapStateToProps, mapDispatchToProps)(HTMLEditor)
    : HTMLEditor;

export default ConnectedHTMLEditor;
